import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Page from '../containers/page';

import ServiceForm from '../components/forms/serviceForm';
import BlogForm from '../components/forms/blogForm';
import ProjectFrom from '../components/forms/projectFrom';

import {
    Container,
    Row,
    Col,
} from 'reactstrap';
import CategoryForm from '../components/forms/categoryForm';
import SeoForm from '../components/forms/seoForm';


const forms = {
    'services': ServiceForm,
    'blog': BlogForm,
    'blogCategories': CategoryForm,
    'projectsCategories': CategoryForm,
    'projects': ProjectFrom,
    'seo': SeoForm


}

class AddPagePage extends Component {
    constructor(props) {
        super(props);
        this.addPage = this.addPage.bind(this);

        this.state = {
            projectsCategories: [],
            blogCategories: [],
            services: []
        };
    }

    addPage(data) {
        console.log(data);

        fetch('https://api.novamedia.agency/admin/updateOne/' + this.props[0].match.params.collection + '/' + this.props[0].match.params.id, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify(data)
        }).then((res) => res.json()).then((result) => {
            this.props[0].history.push('/collection/' + this.props[0].match.params.collection)
        })
    }

    componentDidMount() {
        if (this.props[0].match.params.id != 'new') {
            fetch('https://api.novamedia.agency/admin/fetchOne/' + this.props[0].match.params.collection + '/' + this.props[0].match.params.id, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`

                }
            }).then((res) => res.json()).then((result) => {
                this.setState({
                    initialValues: result
                })
                console.log(result);
            })
        }


        fetch('https://api.novamedia.agency/admin/fetch/blogCategories', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        }).then((res) => res.json()).then((result) => {
            console.log(result);
            this.setState({
                blogCategories: result
            })
        })
        fetch('https://api.novamedia.agency/admin/fetch/projectsCategories', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        }).then((res) => res.json()).then((result) => {
            console.log(result);
            this.setState({
                projectsCategories: result
            })
        })

        fetch('https://api.novamedia.agency/admin/fetch/services', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
        }).then((res) => res.json()).then((result) => {
            console.log(result);
            this.setState({
                services: result
            })
        })

    }


    render() {
        if (!this.props[0].match.params.collection){
            return null;
        }
        const Form = forms[this.props[0].match.params.collection];
        return (
            
            <div className="page-wrap">
                {
                    !localStorage.token ? <Redirect to='/login' /> : null
                }

                <Container fluid>

                    <Row className="page-title">
                        <Col lg="12">
                            {this.props[0].match.params.id !== 'new' ? <h3>Izmjeni</h3> : <h3>Dodaj</h3>}
                        </Col>

                    </Row>

                    {this.state.initialValues ?
                        <Form blogCategories={this.state.blogCategories} projectsCategories={this.state.projectsCategories} services={this.state.services} lang={this.props.lang} collection={this.props[0].match.params.collection} initialValues={this.state.initialValues} onSubmit={this.addPage} />
                        :
                        <Form blogCategories={this.state.blogCategories} projectsCategories={this.state.projectsCategories} services={this.state.services} lang={this.props.lang} collection={this.props[0].match.params.collection} onSubmit={this.addPage} />
                    }
                </Container>


            </div>
        );
    }
}

export default Page(AddPagePage);